export function getRobotsContent(directives) {
    return "max-image-preview:large".concat(directives ? ", ".concat(directives) : '');
}
//# sourceMappingURL=head.js.map